
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.77 28.162V26.43C8.77 19.58 14.35 14 21.2 14h16.89c6.85 0 12.43 5.58 12.43 12.43v1.614a3.929 3.929 0 013.27 3.866c0 1.097-.456 2.09-1.187 2.803a3.909 3.909 0 011.187 2.807 3.936 3.936 0 01-3.377 3.882 6.531 6.531 0 01-6.443 5.458H15.3a6.544 6.544 0 01-6.47-5.574A3.93 3.93 0 016 37.52c0-1.098.455-2.092 1.185-2.805A3.909 3.909 0 016 31.91a3.93 3.93 0 012.77-3.748zm26.764 7.668l-3.097 3.37H49.87c.93 0 1.69-.76 1.69-1.69 0-.878-.678-1.605-1.536-1.683l-.064.002h-.065l-.025.001H35.534zm-8.191 3.37l-3.097-3.37H9.92c-.052 0-.103-.001-.154-.003A1.695 1.695 0 008.23 37.51c0 .93.76 1.69 1.69 1.69h17.423zm10.24-5.6l3.096-3.37h9.191c.93 0 1.69.76 1.69 1.69 0 .878-.678 1.605-1.536 1.683a3.941 3.941 0 00-.154-.003H37.583zm.077-3.37H22.12l3.346 3.64c.064.055.122.117.171.185l4.253 4.625 7.77-8.45zM22.197 33.6l-3.096-3.37H9.92c-.93 0-1.69.76-1.69 1.69 0 .878.678 1.605 1.536 1.683.051-.002.102-.003.154-.003h12.277zM11.14 41.44h37.01c-.5 1.84-2.18 3.2-4.17 3.2H15.31c-2 0-3.68-1.36-4.17-3.2zm-.15-13.45v-1.57c0-5.62 4.57-10.2 10.2-10.2h16.89c5.62 0 10.2 4.57 10.2 10.2v1.57H10.99zm8.95-7.96a.9.9 0 11-1.8 0 .9.9 0 011.8 0zm-3.7 3.88a.9.9 0 100-1.8.9.9 0 000 1.8zm5.35.1a.9.9 0 11-1.8 0 .9.9 0 011.8 0zm21.88-.89a.9.9 0 100-1.8.9.9 0 000 1.8z"}})])
          )
        }
      }
    